import { useEffect, useState } from 'preact/hooks';

export function navigate(to: string, replace = false): void {
  if (replace) history.replaceState(null, '', to); else history.pushState(null, '', to);
  dispatchEvent(new PopStateEvent('popstate'));
}

export function useLocation(): { pathname: string; search: string } {
  const get = () => ({ pathname: location.pathname, search: location.search });
  const [loc, setLoc] = useState(get);
  useEffect(() => {
    const on = () => setLoc(get());
    addEventListener('popstate', on);
    return () => removeEventListener('popstate', on);
  }, []);
  return loc;
}
